<template>
  <div class="homeleftalbumhot">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Chủ đề Hot
        </h1>
      </div>

      <div class="right">
        <pagination
          :total-pages="totalPage"
          :total="totalRecord"
          :per-page="pageSize"
          :current-page="currentPage"
          @pagechanged="onPageChange"
          :previous-name="previousName"
          :next-name="nextName"
        >
          <span class="page">{{ currentPage}}/{{ totalPage }}</span>
        </pagination>
      </div>

      <div style="clear: both"></div>
    </div>

    <div class="content">
      <div class="col-md-5 featured float-left" v-for="item in dataList.slice(0,1)">
        <a :href="prefixUrl + item.albumCode">
          <img class="thumbnail" :src="item.avatar != '' ? item.avatar : defaultThumbnail" />
          <h4 class="song color-text">{{ item.albumName }}</h4>
          <!--<p class="singer color-text">Đàm Vĩnh Hưng</p>-->
        </a>
      </div>

      <div class="col-md-7 float-right normal">
        <div class="row">
          <div v-for="item in dataList.slice(1,5)" class="col-md-6 box">
            <a :href="prefixUrl + item.albumCode">
              <img class="thumbnail" :src="item.avatar != '' ? item.avatar : defaultThumbnail" />
              <h4 class="song color-text">{{ item.albumName }}</h4>
              <!--<p class="singer color-text">Đàm Vĩnh Hưng</p>-->
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '../../Pagination'
  export default {
    name: "YouMayLike",
    components: {
      "pagination": Pagination
    },
    data(){
      return{
        pageSize: 5,
        currentPage: 1,
        totalRecord: 1,
        totalPage: 2,
        previousName: "previousArrow",
        nextName: "nextArrow",
        dataList: [],
        defaultThumbnail: this.settings.defaultThumbnailAlbum,
        prefixUrl: this.settings.prefixAlbum
      }
    },
    created(){
      this.getDataList();
    },
    methods: {
      getDataList(){
        var dataPost = {
          "pageIndex": this.currentPage,
          "pageSize": this.pageSize,
      };
        axios.post(api.albumHot, dataPost)
          .then(response => {
            this.dataList = response.data.result;
            this.totalRecord = response.data.totalRecord;
            //this.totalPage = response.data.totalPage;
          }).catch(error => {
          console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      }
    },
    watch: {
      "currentPage": {
        handler: 'getDataList',
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .content{
    text-align: left;
  }
  .featured{
    padding: 0 !important;
  }
  .featured img{
    width: 100%;
    height: 220px;
  }
  .normal{
    padding-right: 0 !important;
  }
  .normal img{
    width: 100%;
    height: 94px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/web/AlbumHot.vue